import React, { useState, useEffect } from "react";
import "../styles/About.css";
import teamImage from "../assets/about.png";
import capacities from "../assets/capacities.png";
import ContactSection from "../components/ContactSection";

const capabilitiesData = [
  {
    id: "001",
    title: "Brand Strategy & Identity",
    description:
      "Comprehensive brand development from strategic foundation through visual and verbal identity systems. We define positioning, architecture, messaging and scalable identity systems built for consistency across every touchpoint.",
  },
  {
    id: "002",
    title: "Website Design & Development",
    description:
      "We design and develop modern, responsive websites that combine stunning visuals with seamless functionality. Our solutions are optimized for performance, scalability, and user engagement.",
  },
  {
    id: "003",
    title: "Digital Marketing & Growth",
    description:
      "From SEO and content marketing to paid advertising and social media management, we create data-driven campaigns that increase visibility, generate leads, and accelerate business growth.",
  },
];

const AboutCapabilities = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev === capabilitiesData.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? capabilitiesData.length - 1 : prev - 1
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === capabilitiesData.length - 1 ? 0 : prev + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const currentCapability = capabilitiesData[currentIndex];

  return (
    <>

   
    <section className="grownex-about-page">

      {/* ================= ABOUT ================= */}

      <div className="grownex-about-row">

        <div className="grownex-about-content">

          <span className="grownex-about-section-tag">
            About Us
          </span>

          <h2 className="grownex-about-title">
            Crafting Brands That <span>Matter</span>
          </h2>

          <p className="grownex-about-text">
            We exist to create brands that matter and marketing that moves
            markets. Not brands that exist only in guidelines, but identities
            that shape perception, drive preference, and create commercial
            value.
          </p>

          <p className="grownex-about-text">
            With a team of skilled professionals and a commitment to quality,
            we work hand-in-hand with our clients to bring their ideas to life.
            Together, we create brands and solutions that stand the test of
            time.
          </p>

        </div>

        <div className="grownex-about-image-wrapper">
          <img
            src={teamImage}
            alt="Team"
            className="grownex-about-image"
          />
        </div>

      </div>

      {/* ================= CAPABILITIES ================= */}

      <div className="grownex-about-capabilities">

        <div className="grownex-about-cap-header">

          <div className="grownex-about-cap-label">
            <span>Our</span>
            <span>Capabilities</span>
          </div>

          <h2 className="grownex-about-cap-heading">
            Capabilities<span>.</span>
          </h2>

          <p className="grownex-about-cap-description">
            See how our full-spectrum capabilities transform your brand with
            custom strategies that deliver measurable impact.
          </p>

        </div>

        <div className="grownex-about-cap-card">

          <div className="grownex-about-cap-image">
            <img
              src={capacities}
              alt="Capabilities"
            />
          </div>

          <div className="grownex-about-cap-content">

            <span className="grownex-about-small-number">
              {currentCapability.id} /
            </span>

            <h3 className="grownex-about-cap-title">
              {currentCapability.title}
            </h3>

            <p className="grownex-about-cap-text">
              {currentCapability.description}
            </p>

            <div className="grownex-about-slider-nav">
                            <button
                type="button"
                onClick={prevSlide}
                className="grownex-about-slider-btn"
              >
                ←
              </button>

              <button
                type="button"
                onClick={nextSlide}
                className="grownex-about-slider-btn"
              >
                →
              </button>

              <div className="grownex-about-slider-line">
                {capabilitiesData.map((_, index) => (
                  <span
                    key={index}
                    className={
                      index === currentIndex
                        ? "grownex-about-indicator grownex-about-indicator-active"
                        : "grownex-about-indicator"
                    }
                    onClick={() => setCurrentIndex(index)}
                  />
                ))}
              </div>

            </div>

          </div>

        </div>

      </div>

      {/* ================= MISSION & VISION ================= */}

      <div className="grownex-about-vision-section">

        <div className="grownex-about-vision-card">

          <span className="grownex-about-section-tag">
            Our Mission
          </span>

          <h3 className="grownex-about-vision-title">
            Building brands that drive growth
          </h3>

          <p className="grownex-about-vision-text">
            To deliver exceptional branding and marketing solutions that exceed
            client expectations through innovation, quality craftsmanship, and
            a commitment to measurable results.
          </p>

          <ul className="grownex-about-vision-list">
            <li>Strategic clarity in every engagement</li>
            <li>Innovation-driven creative solutions</li>
            <li>Customer-centric approach</li>
            <li>Building stronger market presence</li>
          </ul>

        </div>

        <div className="grownex-about-vision-card">

          <span className="grownex-about-section-tag">
            Our Vision
          </span>

          <h3 className="grownex-about-vision-title">
            Redefining the future of branding
          </h3>

          <p className="grownex-about-vision-text">
            To redefine the future of branding and marketing through innovation,
            sustainability and excellence.
          </p>

          <ul className="grownex-about-vision-list">
            <li>Inspiring modern brand architecture</li>
            <li>Pioneering digital-first strategies</li>
            <li>Championing measurable outcomes</li>
            <li>Empowering ambitious businesses</li>
          </ul>

        </div>

      </div>

    </section>

    <ContactSection />
     </>
  );
};

export default AboutCapabilities;